import React from "react";
import Modal from "../../../../../../components/Common/Modal/Modal";
import ViewCertificate from "../ViewCertificate";

const ViewCertificateModal = ({
  isViewModal,
  setIsViewModal,
  title,
  selectedCertificate,
}) => {
  return (
    <Modal
      isOpen={isViewModal}
      heading={"View Certificate"}
      toggle={() => setIsViewModal(false)}
      width={"50"}
    >
      <ViewCertificate
        title={title}
        selectedCertificate={selectedCertificate}
      />
    </Modal>
  );
};

export default ViewCertificateModal;
